import { Location, LocationStrategy } from '@angular/common';
import { Directive, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IDictionaryQuery } from '../interfaces/models/idictionary-query.model';
import { IIdEntity } from '../interfaces/models/iid-entity';
import { IPageableList } from '../interfaces/models/ipageable-list.model';
import { AppSettings } from '../models/appsettings';
import { EntityState } from '../models/enums';
import { EventsService } from '../services/events.service';
import { ModelBaseService } from '../services/model-base.service';
import { UserContextService } from '../services/user-context.service';
import { VisualCmptRoleBaseComponent } from './visual-cmpt-roles-base.component';

@Directive({
    selector: 'demo',
    standalone: false
})

export abstract class ModelListBaseComponent<TKey, T extends IIdEntity<TKey>> extends VisualCmptRoleBaseComponent {

  @Output() getTotalRows = new EventEmitter<number>();

  isEditable: boolean = true;
  rowsPerPage: number = AppSettings.dictionaryRowsPerPage;
  suggestionsRowsPerDdl: number = AppSettings.suggestionsRowsPerDdl;
  //checkEntityStateType: any = EntityState;  
  entities: T[] = [];
  appendLoadedEntities = false;
  // #region paging
  pageOffset: number = 0;
  tableTotalRows: number = 0;
  currentPage = 0;
  firstPageRow = 0;
  pageCount = 0;
  isFirstPage = true;
  isLastPage = false;
  // #endregion paging

  constructor(
    protected events: EventsService,
    protected modelSvc: ModelBaseService<T>,
    protected userContextSvc: UserContextService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected location: Location,
    protected locationStrategy: LocationStrategy) {

    super(events, userContextSvc, router, route, location);
  }

  abstract onLazyLoad(e);

  ngOnInit() {
    super.ngOnInit();

    if (this.routerTree.queryParams) {
      if (this.routerTree.queryParams.pageOffset) {
        this.pageOffset = this.routerTree.queryParams.pageOffset;
      }
    }
  }

  setRequestQueryParams(event) {
    let requestPageOffset = null;
    if (event && event.first > 0)
      requestPageOffset = event.first;
    const queryParamsObj = { pageOffset: requestPageOffset };

    this.location.replaceState(
      this.router.createUrlTree(
        [this.locationStrategy.path().split('?')[0]], // Get current uri
        { queryParams: queryParamsObj } // Pass all parameters to queryParams
      ).toString()
    );
  }

  resetPagingParams() {
    // для изменения состояния пагинатора, необходимо для ViewChild пагинатора this.paginator.changePage(0);
    this.pageOffset = 0;
    this.tableTotalRows = 0;
    this.setRequestQueryParams(null);
  }

  editRow(model) {
    model.State = EntityState.Edit;
  }

  removeFromCurrentItems(model) {
    this.entities = this.entities.filter(x => x.Id !== model.Id);
  }

  onPageChange(event) {
    this.setRequestQueryParams(event);
  }

  changePage(p: number) {
    if (p >= 0 && p < this.pageCount) {
      this.firstPageRow = this.entities.length * p;
      this.currentPage = p;
    }
  }

  loadPagedPromise(query: IDictionaryQuery): Promise<any> {
    if (this.loading)
      return new Promise((resolve) => { resolve(null); });    
    
    this.loading = true;
    return this.modelSvc.fetchPaged(query).toPromise()
      .then((x) => { return this.handleLoadPagedPromiseSuccess(x); })
      .catch((err) => { return this.handleLoadPagedPromiseError(err); });
  }

  loadPaged(query: IDictionaryQuery) {
    var success = (x: IPageableList<T>): void => {
      this.loading = false;      
    };
    var error = (err: any): void => {
    };
    this.loadPagedPromise(query)
      .then((x) => { success(x); })
      .catch((err) => { error(err); });
  }

  handleLoadPagedPromiseSuccess(res: IPageableList<T>) {
    if (this.appendLoadedEntities)
      this.entities.push(...res.Items);
    else
      this.entities = res.Items;
    this.setPagingState(res);
    if (!this.initialDataLoaded)
      this.onInitialDataLoadingComplete();
    return Promise.resolve(res);
  }

  handleLoadPagedPromiseError(err: any): Promise<never> {
    return this.handleLoadError(err);
  }

  setPagingState(res: IPageableList<T>) {
    this.tableTotalRows = res.TotalCount;

    this.pageCount = Math.ceil(this.tableTotalRows / this.rowsPerPage) || 1;
    this.currentPage = res.Skipped / this.rowsPerPage;
    this.isFirstPage = this.currentPage == 0;
    this.isLastPage = this.currentPage == this.pageCount - 1;

    this.getTotalRows.emit(this.tableTotalRows);
  }

  loadLastPage() {
    let paging = {
      first: ((this.pageCount - 1) * this.rowsPerPage),
      rows: this.rowsPerPage
    };
    this.onLazyLoad(paging);
    this.pageOffset = paging.first;
    //this.paginator.changePageToLast(new Event("empty")); // не работает на второй раз
  }

  loadNextPage() {
    let paging = {
      first: ((this.currentPage + 1) * this.rowsPerPage),
      rows: this.rowsPerPage
    };
    this.onLazyLoad(paging);
    this.pageOffset = paging.first;    
  }

  filterTableQuery(value, fieldName, filterType, fieldType, table, query) {
    switch (fieldType) {
      case '[object Array]': {
        if (value != undefined && value != null)
          query[fieldName] = [value];
        else
          query[fieldName] = [];
        break;
      }
      default: {
        query[fieldName] = value;
        break;
      }
    }
    // т.к. остальное устанавливается по стандартному объекту e.filters на событии tt.filter, то вызываем без аргументов
    // table.filter(value, fieldName, filterType);
    table.filter();
  }

  entityState(item: T) {
    if (!item.State)
      return this.modelViewState;
      return item.State;
  }
}
